import { Field } from 'formik';
import formikMetaToState from '../../helpers/formikMetaToState';
import { InputText, InputTextProps } from '../InputText';

export const FormikInputText = (props: InputTextProps & { name: string }) => {
  const { name } = props;
  return (
    <Field name={name}>
      {({ field, meta }: any) => {
        const { error, state } = formikMetaToState(meta);
        return <InputText {...field} {...props} error={error} state={state} />;
      }}
    </Field>
  );
};
